export function getTillLate(proposedDeliveryGroups, order) {
    if (proposedDeliveryGroups && order?.status === 'READY') {
        const orderSendProposal = proposedDeliveryGroups.flatMap(group => group.route).find(o => o.order_id === order.id);

        if (orderSendProposal) {
            const minutesTillProposedArrival = (orderSendProposal.order_duration / 60).toFixed(2);

            let percentTillLate = Math.round((minutesTillProposedArrival / order.sla) * 100);

            const minutesTillLate = order.sla - minutesTillProposedArrival;

            if (percentTillLate > 100)
                percentTillLate = 100;

            return {minutesTillProposedArrival, minutesTillLate, percentTillLate}
        }
    }

    return undefined;
}